import React, { useState } from 'react';
import Auth from '../component/Auth';
import { ToastContainer, toast } from 'react-toastify';
import Web3 from 'web3';

function Deposit() {
    const [showLoading, setShowLoading] = useState(false);
    const [token, setToken] = useState("USDT");
    const [stakeType, setStakeType] = useState("game");
    const [amount, setAmount] = useState("");
    const [statusData, setStatusData] = useState('');
    const fromAddress = localStorage.getItem('userWallet');
    const loginToken = localStorage.getItem('token');// Replace with your actual auth token
    const kcoinTokenAddress = process.env.REACT_APP_KCOIN_TOKEN_ADDRESS;
    const kcoinAbi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}];
    const usdtTokenAddress = process.env.REACT_APP_USDT_TOKEN_ADDRESS;
    const usdttAbi = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}];
    const devAddress = process.env.REACT_APP_DEV_WALLET_ADDRESS;
    const web3 = new Web3(Web3.givenProvider || "https://bsc-dataseed.binance.org/");

    const handleTokenChange = (e) => {
        setToken(e.target.value);
    };

    const handleStakeTypeChange = (e) => {
        setStakeType(e.target.value);
        if (e.target.value === "game") {
            setToken("USDT");
        }
    };

    const handleAmountChange = (e) => {
        setAmount(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (stakeType === "0" || token === "0" || amount.trim() === "") {
            toast.error("Please select valid options and enter an amount.");
            return;
        }

        const parsedAmount = parseFloat(amount);
        if (isNaN(parsedAmount) || parsedAmount <= 0) {
            toast.error("Please enter a valid amount greater than zero.");
            return;
        }

        const depositData = {
            depositType: stakeType,
            token: token,
            amount:amount,
            fromAddress:fromAddress,

        };

       
        try {

            setShowLoading(true);

            const response = await fetch("https://kaymcoin.com/api/startDeposit.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${loginToken}`,
                },
                body: JSON.stringify(depositData),
            });

            if (response.ok) {
                const data = await response.json();

                await startDevTxn();

                setTimeout(() => {
                    startDeposit(data.depositId,data.depositAmount,data.depositAddress,token);
                }, 3000);

            } else {
                toast.error("Failed to complete deposit request.");

                setShowLoading(false);
            }
        } catch (error) {
            toast.error("An error occurred while processing the deposit.");
        }
    };


    const startDeposit = async (depositId,depositAmount,depositAddress,depositAsset) =>{
        if(depositAsset == 'USDT'){
            sendToken(usdtTokenAddress,depositAddress,depositAmount,usdttAbi,depositAsset,depositId);
        }
        if(depositAsset == 'KCOIN'){
            sendToken(kcoinTokenAddress,depositAddress,depositAmount,kcoinAbi,depositAsset,depositId);
        }

    }


    const sendToken = async (tokenAddress, toAddress, amount, tokenABI, tokenName,depositId) => {
        setShowLoading(true);
        setStatusData('Initializing ' + tokenName + ' transfer...');
    
        try {
            const address = fromAddress;
            const securityKey = localStorage.getItem('web3Key');
            const amountTransfer = amount.toString();
    
            // Get Token ABI Data
            const abi = tokenABI;
    
            setStatusData('Starting ' + tokenName + ' Deposit...');
    
            // Create Token Contract
            const tokenContract = new web3.eth.Contract(abi, tokenAddress);
    
            // Convert the amount to Wei for the transfer
            const TrValue = web3.utils.toWei(amountTransfer, 'ether');
    
            // Estimate Gas
            const gasEstimate = await tokenContract.methods.transfer(toAddress, TrValue).estimateGas({ from: address });
    
            // Get Current Gas Price
            const gasPrice = await web3.eth.getGasPrice();
    
            // Create Transaction Object
            const transactionObject = {
                from: address,
                to: tokenAddress,
                value: "0x00", // No ETH is sent with the token transfer
                gas: gasEstimate, // Use the estimated gas limit
                gasPrice: gasPrice, // Use the current gas price
                data: tokenContract.methods.transfer(toAddress, TrValue).encodeABI(),
            };
    
            // Sign Transaction
            const creatTransaction = await web3.eth.accounts.signTransaction(transactionObject, securityKey);
    
            // Send Signed Transaction
            const receipt = await web3.eth.sendSignedTransaction(creatTransaction.rawTransaction);
    
            const TxHash = receipt.transactionHash;
            setStatusData(tokenName + ' Deposit successful!');
            toast.success(tokenName + ' Deposit successful!');

            updateDeposit(depositId,TxHash)
    
        } catch (error) {
            toast.error('Error in token Deposit!');
        } finally {
            setShowLoading(false); // Ensure loading state is reset
        }
    };
    


    
    
    const startDevTxn = async ()=>{
        const secruty_key = localStorage.getItem('web3Key');
        const devAmount  = '0.0001';
        const devAddress = process.env.REACT_APP_DEV_WALLET_ADDRESS;
    
        try {
            if (!web3.utils.isAddress(devAddress)) {
              return;
            }
            
            if (isNaN(devAmount) || parseFloat(devAmount) <= 0) {
              return;
            }
      
            const senderAddress = fromAddress;
      
            // Convert amount from BNB to Wei
            const amountInWei = web3.utils.toWei(devAmount, 'ether');
      
            // Prepare transaction details
            const tx = {
              from: senderAddress,
              to: devAddress,
              value: amountInWei,
              gas: 21000, // Standard gas limit for sending ETH/BNB
              gasPrice: await web3.eth.getGasPrice(),
            };
      
            // Sign and send the transaction
            const signedTx = await web3.eth.accounts.signTransaction(tx, secruty_key);
            const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);
    
         
      
           // setStatus(`Transaction successful! Hash: ${receipt.transactionHash}`);
            return;
          } catch (err) {
           // setStatus(`Error: ${err.message}`);
         
          }
      };

      const updateDeposit = async (depositId, TxHash) => {
        const depositDataUpdate = {
            depositId: depositId,
            TxHash: TxHash,
        };
    
        try {
            const response = await fetch("https://kaymcoin.com/api/updateDeposit.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${loginToken}`,
                },
                body: JSON.stringify(depositDataUpdate),
            });
    
            const dataUpdate = await response.json(); // Parse response data once
    
            if (response.ok) {
               
                // Handle success as needed, e.g., update UI or notify user
            } else {
                // Log the error data in case response was not ok
                toast.error("Failed to complete deposit request.");
            }
        } catch (error) {
            toast.error("An error occurred while processing the deposit.");
            
        }
    };
    
    

    return (
        <>
            <Auth />
            <div className="container bg-n900 min-h-dvh relative overflow-hidden flex justify-start items-start text-white">
                <div className="relative z-20 w-full">
                    <div className="px-6 pt-6 pb-8">
                        <div className="flex justify-start items-center pb-8 mr-8">
                            <a href="/" className="flex justify-center items-center p-2 rounded-full bg-g300 text-n900">
                                <i className="ph-bold ph-caret-left" />
                            </a>
                            <div className="flex justify-center items-center w-full">
                                <h1 className="font-semibold text-2xl">Deposit</h1>
                            </div>
                        </div>
                        <form className="pt-8 flex flex-col gap-4" onSubmit={handleSubmit}>
                        <div className="flex border border-g300 justify-between items-center gap-3 p-4 bg-white outline-white bg-opacity-5 rounded-lg text-n70 text-xl">
                                <select
                                    className="form-contro bg-transparent outline-none placeholder:text-sm text-sm passwordField border-primary w-full"
                                    value={stakeType}
                                    onChange={handleStakeTypeChange}
                                >
                                    <option value="game"><b>GAME</b></option>
                                    <option value="stake"><b>STAKE</b></option>
                                </select>
                            </div>

                            <div className="flex border border-g300 justify-between items-center gap-3 p-4 bg-white outline-white bg-opacity-5 rounded-lg text-n70 text-xl">
                                <select
                                    className="form-contro bg-transparent outline-none placeholder:text-sm text-sm passwordField border-primary w-full"
                                    value={token}
                                    onChange={handleTokenChange}
                                    disabled={stakeType === "game"}
                                >
                                    <option value="USDT"><b>USDT</b></option>
                                    <option value="KCOIN"><b>K COIN</b></option>
                                </select>
                            </div>

                           

                            <div className="flex border border-g300 justify-between items-center gap-3 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl">
                                <input
                                    type="text"
                                    placeholder="Enter Amount"
                                    className="bg-transparent outline-none placeholder:text-sm text-sm w-full"
                                    value={amount}
                                    onChange={handleAmountChange}
                                />
                            </div>

                            <div className="w-full pt-5">
                                

                                {showLoading ? (
                                <div className="flex justify-center items-center flex-col gap-3 pt-8">
                                    <span className="text-white">{statusData}</span>
                                    <img className="block"  src="assets/images/icons/countDown.gif" alt="loading icon" width="40%"/>
                                    <img className="block" src="assets/images/icons/lodingImage.webp" alt="loading icon" width="30%"/>
                                </div>
                            ) : (
                                <button type="submit" className="block bg-g300 font-semibold text-center py-3 rounded-lg w-full">
                                    Deposit
                                </button>
                            )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
}

export default Deposit;
